import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { HStack } from "@design-system/HStack/HStack";
import { CatalogItemRow } from "./catalogItems.types";
import styles from "./CatalogItemFormModal.module.scss";

interface Props {
    item?: CatalogItemRow | null;
    isPending: boolean;
    isValid: boolean;
    onHide: () => void;
    presentation: "modal" | "drawer";
}

export const CatalogItemFormFooter: React.FC<Props> = ({
    item,
    isPending,
    isValid,
    onHide,
    presentation,
}) => {
    const isEditing = Boolean(item);
    const submitLabel = isEditing ? "Save" : "Create";
    const submitButton = (
        <ButtonWithLoader
            variant="primary"
            loading={isPending}
            size={presentation === "drawer" ? "md" : "xl"}
            type="submit"
            disabled={!isValid}
            hotKey="mod+enter"
            hotKeyDisplayPosition="inline"
            hotKeyOptions={{
                description: isEditing ? "Save item" : "Create item",
                preventDefault: true,
                enableOnFormTags: true,
            }}
        >
            {submitLabel}
        </ButtonWithLoader>
    );

    if (presentation === "drawer") {
        return (
            <CommandIsland className={styles.commandBar}>
                <Button
                    type="button"
                    variant="primary"
                    size="md"
                    disabled={isPending}
                    onClick={onHide}
                >
                    Cancel
                </Button>
                {submitButton}
            </CommandIsland>
        );
    }

    return (
        <HStack as="footer" gap={12} justify="end" className="mt-3">
            <HStack gap={12}>
                <Button
                    type="button"
                    variant="secondary"
                    disabled={isPending}
                    onClick={onHide}
                    size="xl"
                >
                    Cancel
                </Button>
                {submitButton}
            </HStack>
        </HStack>
    );
};
